export default __webpack_public_path__ + "static/media/BLAZE-Logo-Flat-allBlue.cf56bea6.svg";